import React from 'react';
import { Form } from 'semantic-ui-react';
import QueuesSelector from '../../widgets/queues-selector';
import { Label } from './label';
import { setupField } from '../utils/form-utils';
import { FieldError } from './field-error';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function QueuesField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline>
      <Label>Queues</Label>
      <QueuesSelector
        {...field}
        multiple
        value={field.value || []}
        onChange={handleChange}
        onBlur={handleBlur}
        error={error}
      />
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
